import React from 'react';
import { trans, getPagePath } from '@spotahome/soyuz/client';
import CookiesBanner from '@spotahome/ui-library/lib/components/CookiesBanner';

const COOKIES_ROUTE_ID = 'externals.cookies-policy';
const COOKIES_MESSAGE = 'landingpage.label.cookies_improve_experience';
const COOKIES_BUTTON = 'global.cookies.button';
const COOKIES_LINK_TEXT = 'landingpage.label.cookies_learn_more';

const Cookies = () => (
  <CookiesBanner
    message={trans(COOKIES_MESSAGE)}
    link={getPagePath(COOKIES_ROUTE_ID)}
    linkText={trans(COOKIES_LINK_TEXT)}
    buttonText={trans(COOKIES_BUTTON)}
  />
);

export default Cookies;
